import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { fetchRoleById } from '@/features/assessments/api/fetch-role-by-id'
import { materializeUsers } from '@/features/assessments/api/materialize-users'
import { usersKeys } from '@/features/assessments/api/users-list'

// Ops API role IDs are environment-specific — kept hardcoded for v1 parity.
export const SALES_ENGINEER_ROLE_ID = '66fad67e8c5827003c8e89b9'
export const ACCOUNT_EXECUTIVE_ROLE_ID = '66f9958b5a3027a67242b28b'

const ROLE_IDS_TO_SYNC = [SALES_ENGINEER_ROLE_ID, ACCOUNT_EXECUTIVE_ROLE_ID] as const

async function syncSalesEngineerRoleUsers() {
  const roles = await Promise.all(ROLE_IDS_TO_SYNC.map(roleId => fetchRoleById(roleId)))

  const ids = [...new Set(roles.flatMap(role => (role.members ?? []).map(member => member.userId)))]

  if (ids.length === 0) return 'no-users' as const

  await materializeUsers({ ids })
  return 'synced' as const
}

export function useSyncSalesEngineerRoleUsers() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: syncSalesEngineerRoleUsers,
    onSuccess: result => {
      if (result === 'no-users') {
        toast.warning('No users found in the Sales Engineer and Account Executive roles')
        return
      }
      toast.success('Users synced')
      void queryClient.invalidateQueries({ queryKey: usersKeys.all })
    },
    onError: () => {
      toast.error('Failed to sync users')
    }
  })
}
